module.exports = __webpack_public_path__ + "img/Recurso 12.5094bf92.png";